import { Empty, List } from 'antd';
import { FC } from 'react';
import { type FileCard as FileCardType } from 'services';
import { FileCard } from './FileCardV2';

type SelectedFilesListProps = {
  items: FileCardType[];
  toggleItem: (item: FileCardType) => void;
};

export const SelectedFilesList: FC<SelectedFilesListProps> = ({ items, toggleItem }) => {
  if (!items.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No files selected, yet...." />;
  return (
    <div className="flex flex-col gap-2">
      <List
        grid={{
          gutter: 8,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 4,
          xl: 4,
          xxl: 4,
        }}
        dataSource={items}
        renderItem={(item) => (
          <FileCard
            file={item}
            key={item.id}
            isChecked
            onClick={(file) => {
              toggleItem(file);
            }}
          />
        )}
      />
    </div>
  );
};
